import script from "./kyt-detail.vue?vue&type=script&setup=true&lang=ts"
export * from "./kyt-detail.vue?vue&type=script&setup=true&lang=ts"

import "./kyt-detail.vue?vue&type=style&index=0&id=535b79b8&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-535b79b8"]])

export default __exports__